function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.27912 2H12.7207C13.4242 2 14 2.62586 14 3.39097V16.609C14 17.3741 13.4244 18 12.7207 18H6.27912C5.57562 18 5 17.3743 5 16.609V3.39097C5 2.62586 5.57546 2 6.27912 2ZM9.49992 16.9973C9.95157 16.9973 10.3173 16.5993 10.3173 16.1082C10.3173 15.6172 9.95157 15.2191 9.49992 15.2191C9.04843 15.2191 8.68273 15.6172 8.68273 16.1082C8.68273 16.5993 9.04859 16.9973 9.49992 16.9973ZM5.81784 14.2106H13.182V4.32178H5.81784V14.2106Z"
});

var SvgDevice = function SvgDevice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDevice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/device.470f253c.svg";
export { ForwardRef as ReactComponent };